@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../constants/spacing.module.less';
@import '../../../../constants/screen-width-breakpoints.module.less';

.feature-cards-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 490px));
  gap: @space-16;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1000px;
}

.feature-cards-title {
  grid-column: 1 / -1;
  margin-bottom: @space-8;
}

.feature-card {
  display: flex;
  width: 100%;
  min-height: 140px;
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--Current-Grey-400, #c4cdd5);
  background-color: var(--white);
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    border-color: var(--green-00B74A);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
}

.icon-container {
  display: flex;
  min-width: 138px;
  min-height: 138px;
  align-self: stretch;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background: var(--green-EDFDF5);
  border-radius: 8px 0 0 8px;
}

.icon {
  width: 80px;
  height: 80px;
  flex-shrink: 0;
  aspect-ratio: 1/1;
  background: var(--green-EDFDF5);
}

.text-chevron-container {
  display: flex;
  align-items: center;
  gap: @space-16;
  padding: 0 @space-16;
  flex-wrap: nowrap;
}

.text-container {
  display: flex;
  justify-content: center;
  min-height: 140px;
  width: 100%;
  gap: @space-8;
}

.chevron {
  width: 20px;
  height: 20px;
  color: var(--gray-212c36);
}

@media @mobile, @tablet {
  .feature-cards-list {
    grid-template-columns: repeat(auto-fit, minmax(280px, 490px));
    gap: @space-12;
    max-width: 100%;
    padding: 0 @space-16;
  }
}

@media @mobile {
  .feature-cards-title {
    margin-left: @space-16;
  }

  .feature-card {
    min-height: 120px;
    max-width: 100%;
  }

  .icon-container {
    min-width: 100px;
    height: 118px;
  }

  .icon {
    width: 60px;
    height: 60px;
  }

  .text-chevron-container {
    padding: @space-0 @space-12;
    gap: @space-8;
  }

  .text-container {
    min-height: 120px;
    gap: @space-4;
  }

  .chevron {
    width: 16px;
    height: 16px;
  }

  .feature-card-mobile {
    min-height: 44px; // iOS recommended minimum touch target

    .text-container {
      padding: @space-8 @space-0;

      h4 {
        margin-left: @space-0;
        margin-bottom: @space-8;
        font-size: 14px;
        line-height: 1.3;
      }

      p {
        font-size: 13px;
        line-height: 1.4;

        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
  }
}
